import { Badge, Menu, Typography } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

export const StyledBadge = styled(Badge, {
    shouldForwardProp: (prop) => prop !== "pulse",
})<{ pulse?: boolean }>(({ pulse }) => {
    const pulseKeyframes = keyframes`
        0% {
            box-shadow: 0 0 0 0 rgba(255, 105, 135, 0.7);
        }
        70% {
            box-shadow: 0 0 0 10px rgba(255, 105, 135, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(255, 105, 135, 0);
        }
    `;

    return {
        "& .MuiBadge-badge": {
            right: 4,
            top: 4,
            border: `1px solid #fff`,
            padding: "0 4px",
            backgroundColor: "red",
            color: "white",
            ...(pulse && {
                animation: `${pulseKeyframes} 1.5s infinite`,
            }),
        },
    };
});
export const MenuBox = styled(Menu)({
    height: "100%",
    width: "100%",
    marginTop: "1rem",
    "@media(width >= 990px)": {
        marginTop: 0,
    },
});

export const NotifTitle = styled(Typography)({
    fontSize: "16px",
    fontFamily: "Montserrat",
});

export const NotifMessage = styled(Typography)({
    fontSize: "14px",
    fontFamily: "Montserrat",
});
